<template lang="pug">
div(class='splide__slide')
  slot
</template>

<script lang="ts">
export const Slide = {}
export default Slide
</script>
